module.exports = __webpack_public_path__ + "img/ring_g_skip_0_0@3x.4d32b6a3.png";